/**
 * Asset keys to URLs.
 *
 * One indirection on purpose. Today a key resolves to a file this app ships;
 * tomorrow it resolves through the pack manifest the platform pins with
 * `packPin`, fetched from `cdn.activekit.app`. When that lands, this file
 * changes and nothing else does, which is the whole point of the manifest
 * contract (`docs/art-system.md`).
 */

import type { WidgetTemplate } from "../data/contract";

export type AssetKey = "bg" | "coin" | "crystal" | "kit" | "kit-chip";

export function packAsset(template: WidgetTemplate, key: AssetKey): string {
  return `/assets/path/${template}-${key}.webp`;
}
